import * as React from 'react';
import './Road-map.scss';
import config from "../../../config";

const RoadMap = () => {
  const eventTrack = (action: string) => {
    window.gtag('event', action, { 'event_name': action })
  }

  return (
    <div className="nft-road-map">
      <div className="nft-road-map__title">
        <h2>
          PRIZES & AWARDS
        </h2>
      </div>

      <div className="nft-road-map__row">
        <div className="nft-road-map__aim">
          <h4 className="nft-road-map__aim-text">
            <span className="underlined">AUDIENCE AWARD</span>
          </h4>
        </div>
        <ul className="nft-road-map__detail">
            <li className="nft-road-map__detail-item">
              To win the Audience Award you need to score the most points.
            </li>
            <li className="nft-road-map__detail-item">
              <b>Score points by:</b>
            </li>
            <li className="nft-road-map__detail-item no-star">
              <b className="colored">1</b>
              Film views and likes
            </li>
            <li className="nft-road-map__detail-item no-star">
              <b className="colored">2</b>
              Connecting with friends
            </li>
            <li className="nft-road-map__detail-item no-star">
              <b className="colored">3</b>
              <span>Inviting new users to register through your shared link</span>
            </li>
            <li className="nft-road-map__detail-item">
              <span>Your friends can watch the films by purchasing the <b>SHORTS!-PASS starting September 1st</b></span>
            </li>
        </ul>
      </div>

      <a href={config.buy}
         className="nft-road-map__button"
         target="_blank"
         rel="noreferrer"
         onClick={eventTrack.bind(this, 'buy-pass_click')}
      >BUY SHORTS!-PASS</a>

      <div className="nft-road-map__social-links">
        <a href={config.tiktok}
           target="_blank"
           rel="noreferrer"
           className="item tiktok"
           onClick={eventTrack.bind(this, 'tiktok_click')}
        >tiktok</a>

        <a href={config.instagram}
           className="item instagram"
           target="_blank"
           rel="noreferrer"
           onClick={eventTrack.bind(this, 'instagram_click')}
        >instagram</a>

        <div className="separator"/>

        <a href={config.twitter}
           className="item twitter"
           target="_blank"
           rel="noreferrer"
           onClick={eventTrack.bind(this, 'twitter_click')}
        >twitter</a>

        {/*<a href={config.discord}*/}
        {/*   className="item discord"*/}
        {/*   target="_blank"*/}
        {/*   rel="noreferrer"*/}
        {/*   onClick={eventTrack.bind(this, 'discord_click')}*/}
        {/*>discord</a>*/}
      </div>

      <div className="scissor-divider">
        <div className="hr"/>
      </div>

      <div className="nft-road-map__row">
        <div className="nft-road-map__aim">
          <h4 className="nft-road-map__aim-text">
            <span className="underlined">AWARDS</span>
          </h4>
        </div>
        <ul className="nft-road-map__detail">
          <li className="nft-road-map__detail-item">
            Best Short Film
          </li>
          <li className="nft-road-map__detail-item">
            Best Director
          </li>
          <li className="nft-road-map__detail-item">
            Best Editing
          </li>
          <li className="nft-road-map__detail-item">
            Best Acting Performance
          </li>
          <li className="nft-road-map__detail-item">
            Best Cinematography
          </li>
          <li className="nft-road-map__detail-item">
            Audience Award
          </li>
        </ul>
      </div>

      <div className="scissor-divider">
        <div className="hr"/>
      </div>

      <div className="nft-road-map__row">
        <div className="nft-road-map__aim">
          <h4 className="nft-road-map__aim-text">
            <span className="underlined">PRIZES INCLUDE</span>
          </h4>
        </div>
        <ul className="nft-road-map__detail">
          <li className="nft-road-map__detail-item">
            Cash prizes
          </li>
          <li className="nft-road-map__detail-item">
            Awesome giveaways from Argo partners
          </li>
          <li className="nft-road-map__detail-item">
            Film promotion from Argo
          </li>
        </ul>
      </div>

      <div className="scissor-divider">
        <div className="hr"/>
      </div>

      <div className="nft-road-map__row">
        <div className="nft-road-map__aim">
          <h4 className="nft-road-map__aim-text">
            <span className="underlined">XRM PRIZE</span>
          </h4>
        </div>
        <ul className="nft-road-map__detail">
          <li className="nft-road-map__detail-item">
            Winners will get a masterclass on independent film financing with XRM Media’s SVP of Development & Production, Sue Turley.
          </li>
          <li className="nft-road-map__detail-item">
            Los Angeles locals will get a private tour of the state-of-the-art studio XRM Media.
          </li>
        </ul>
      </div>

      {/*<div className="scissor-divider right">*/}
      {/*  <div className="hr"/>*/}
      {/*</div>*/}

      {/*<div className="nft-road-map__row">*/}
      {/*  <div className="nft-road-map__aim">*/}
      {/*    <h4 className="nft-road-map__aim-text">*/}
      {/*      <span className="underlined">GAMING</span>*/}
      {/*      /!*<br/>*!/*/}
      {/*      /!*<span className="underlined">CHALLENGE</span>*!/*/}
      {/*    </h4>*/}
      {/*  </div>*/}
      {/*  <ul className="nft-road-map__detail">*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      COLLECT DIFFERENT CHARACTER TO COMPLETE STORY MODE FILM-THEMED MISSIONS*/}
      {/*    </li>*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      MERGE SAME TYPE NFTs AND PARTICIPATE IN THE BATTLE BETWEEN HEROS VS VILLAINS*/}
      {/*    </li>*/}
      {/*  </ul>*/}
      {/*</div>*/}

      {/*<div className="scissor-divider left">*/}
      {/*  <div className="hr"/>*/}
      {/*</div>*/}

      {/*<div className="nft-road-map__row">*/}
      {/*  <div className="nft-road-map__aim">*/}
      {/*    <h4 className="nft-road-map__aim-text">*/}
      {/*      <div className="lg">*/}
      {/*        PLAY TO*/}
      {/*        <br/>*/}
      {/*        <span className="underlined">EARN GAME</span>*/}
      {/*      </div>*/}
      {/*      <div className="sm">*/}
      {/*        <span className="underlined">PLAY TO EARN GAME</span>*/}
      {/*      </div>*/}
      {/*    </h4>*/}
      {/*  </div>*/}
      {/*  <ul className="nft-road-map__detail">*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      IF THE FILM REACHES ITS GOALS, THE FILMMAKERS WILL HOST A GAME OF HEROES VS VILLAINS*/}
      {/*    </li>*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      IT’S A GAME TO THE DEATH SO BE READY TO HAVE YOUR CHARACTER NFTs BURNED*/}
      {/*    </li>*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      FOR NOW ALL THE GAMES ARE TAKING PLACE ON DISCORD*/}
      {/*    </li>*/}
      {/*  </ul>*/}
      {/*</div>*/}

      {/*<div className="scissor-divider right">*/}
      {/*  <div className="hr"/>*/}
      {/*</div>*/}

      {/*<div className="nft-road-map__row">*/}
      {/*  <div className="nft-road-map__aim">*/}
      {/*    <h4 className="nft-road-map__aim-text">*/}
      {/*      <span className="underlined">ARGO COINS</span>*/}
      {/*    </h4>*/}
      {/*  </div>*/}
      {/*  <ul className="nft-road-map__detail">*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      ARGO COINS UNLOCK UNIQUE PRIZES FROM THE FILMS*/}
      {/*    </li>*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      YOU WILL BE ABLE TO EARN COINS BY SUPPORTING FILMS ON ARGO AND BY PARTICIPATING IN NFT CHALANGES*/}
      {/*    </li>*/}
      {/*    /!*<li className="nft-road-map__detail-item">*!/*/}
      {/*    /!*  SOON, YOU WILL BE ABLE TO INVEST ARGO COINS INTO THE FILMS THAT YOU THINK WILL BECOME HITS, AND OWN A PART*!/*/}
      {/*    /!*  OF THAT FILM*!/*/}
      {/*    /!*</li>*!/*/}
      {/*  </ul>*/}
      {/*</div>*/}

      {/*<div className="scissor-divider right">*/}
      {/*  <div className="hr"/>*/}
      {/*</div>*/}

      {/*<div className="nft-road-map__row">*/}
      {/*  <div className="nft-road-map__aim">*/}
      {/*    <h4 className="nft-road-map__aim-text">*/}
      {/*      <span className="underlined">FUTURE RELEASES</span>*/}
      {/*    </h4>*/}
      {/*  </div>*/}
      {/*  <ul className="nft-road-map__detail">*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      MORE FILMS WILL BE RELEASED AS NFT COLLECTIONS, MORE HEROES & VILLAINS WILL EMERGE*/}
      {/*    </li>*/}
      {/*    <li className="nft-road-map__detail-item">*/}
      {/*      THE NFT  CHARACTERS  WILL BE INTERACTIVE ACROSS DIFFERENT FILMS AS THEY EVOLVE*/}
      {/*    </li>*/}
      {/*  </ul>*/}
      {/*</div>*/}
    </div>
  );
}

export default RoadMap;
